import { useMemo } from 'react';
import { FreeLink, pickFreeLinkSettings } from '@elfsight/widget-free-link';
import { useSettings } from '@wu/widget-core';
import { isStandalone, meta } from '../../../constants';
import { getInvertedColor } from '../../helpers';

export const StyledFreeLink = ({
  background
}: {
  background: string | undefined;
}) => {
  const { chatWallpaperMulticolor, ...settings } = useSettings();
  const freeLinkSettings = pickFreeLinkSettings(settings);

  const freeLinkAnchor = isStandalone
    ? freeLinkSettings.freeLinkAnchor
    : 'Free Live Chat Widget By Elfsight';

  const color = useMemo(() => {
    if (chatWallpaperMulticolor?.type === 'native') {
      return 'rgb(177, 177, 177)';
    }

    return background;
  }, [chatWallpaperMulticolor, background]);

  return (
    <FreeLink
      {...freeLinkSettings}
      freeLinkAnchor={freeLinkAnchor}
      appAlias={meta.alias}
      appName={meta.name}
      mode="text"
      textModeProps={{
        color: getInvertedColor({ color })
      }}
      style={{
        link: {
          width: '100%',
          paddingInline: '20px',
          marginBlock: '14px'
        },
        removeText: {
          marginLeft: 'auto'
        }
      }}
    />
  );
};
